<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('ownersView.title') }}</h6>
          <p class="font13 gray-col">{{ $t('ownersView.subtitle') }}</p>
        </div>
        <router-link to="/addOwner" class="main-btn up">{{ $t('ownersView.addOwner') }}</router-link>
      </div>
      <div v-if="!loader">
        <dataTable
          :tableData="filteredOwners"
          :showLink="true"
          :HeadOfTable="HeadOfTable"
          linkDirection="ownerDetails"
        />
      </div>
      <div class="loader-main-axios" v-else>
        <div>{{ $t('ownersView.loadingData') }}</div>
        <div class="spinner-small-white"></div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import dataTable from "../components/dashboard/dataTable.vue";

import { ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from 'vuex';

const { t } = useI18n();
const store = useStore();

// reactive state
const HeadOfTable = ref([
  {
    headText: t('ownersView.serialNumber'),
    headKey: "id",
  },
  {
    headText: t('ownersView.ownerName'),
    headKey: "name",
  },
  {
    headText: t('ownersView.phoneNumber'),
    headKey: "phone",
  },
  {
    headText: t('ownersView.buildingCode'),
    headKey: "ref_types",
  },
  {
    headText: t('ownersView.buildingName'),
    headKey: "buildings",
  },
  {
    headText: t('ownersView.buildingType'),
    headKey: "ref_codes",
  },
  {
    headText: t('ownersView.additionDate'),
    headKey: "created_at",
  },
]);

// computed properties
const filteredOwners = computed(() => store.getters.filteredOwners);
const loader = computed(() => store.getters.isLoading);
// const searchValue = computed(() => store.getters.searchValue);

// functions
const getOwners = () => {
  store.dispatch('fetchOwners');
};

// lifecycle hooks
onMounted(() => {
  getOwners();
});
</script>
